import { render, staticRenderFns } from "./contract_element.vue?vue&type=template&id=5b6f1598&"
import script from "./contract_element.vue?vue&type=script&lang=js&"
export * from "./contract_element.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b6f1598')) {
      api.createRecord('5b6f1598', component.options)
    } else {
      api.reload('5b6f1598', component.options)
    }
    module.hot.accept("./contract_element.vue?vue&type=template&id=5b6f1598&", function () {
      api.rerender('5b6f1598', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/dms/views/contract/contract_element/contract_element.vue"
export default component.exports